const dataProvider = async (_type: string) => {
  const provider = await import('./rest');
  return provider.default;
};

export default dataProvider;
